import React, { useState } from "react";
import { Camera, Play, X, ChevronLeft, ChevronRight, Images } from "lucide-react";

const GalleryPage = () => {
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [activeTab, setActiveTab] = useState("all");

  // Videos
  const galleryVideos = [
    {
      url: "https://customer-assets.emergentagent.com/job_schoolify-17/artifacts/5gqhi7uw_WhatsApp%20Video%202026-02-23%20at%204.11.10%20AM.mp4",
      title: "School Highlights",
      category: "Video",
      type: "video"
    },
    {
      url: "https://customer-assets.emergentagent.com/job_schoolify-17/artifacts/k6l0ynq9_YCPS%2010.mp4",
      title: "Campus Life",
      category: "Video",
      type: "video"
    },
    {
      url: "https://customer-assets.emergentagent.com/job_b5435c93-033f-4e57-8193-8df477e3abd8/artifacts/tzcmk57i_WhatsApp%20Video%202026-03-12%20at%203.21.47%20AM%20%281%29.mp4",
      title: "STEM Learning",
      category: "Video",
      type: "video"
    }
  ];

  // All gallery images (not on homepage)
  const galleryImages = [
    // Moved from homepage
    {
      url: "https://customer-assets.emergentagent.com/job_schoolify-17/artifacts/mh09tbk3_image.png",
      title: "Cultural Day Celebration",
      category: "Culture",
      type: "image"
    },
    {
      url: "https://customer-assets.emergentagent.com/job_schoolify-17/artifacts/gjnwkoph_WhatsApp%20Image%202026-01-20%20at%206.40.16%20AM.jpeg",
      title: "Career Day Professionals",
      category: "Events",
      type: "image"
    },
    {
      url: "https://customer-assets.emergentagent.com/job_schoolify-17/artifacts/3mekrhyk_WhatsApp%20Image%202026-01-20%20at%206.49.00%20AM.jpeg",
      title: "Outdoor Assembly",
      category: "Events",
      type: "image"
    },
    {
      url: "https://customer-assets.emergentagent.com/job_schoolify-17/artifacts/8e08rex9_WhatsApp%20Image%202026-02-20%20at%203.05.16%20AM..jpeg",
      title: "Independence Day",
      category: "Events",
      type: "image"
    },
    {
      url: "https://customer-assets.emergentagent.com/job_schoolify-17/artifacts/nuh15sto_WhatsApp%20Image%202026-02-23%20at%204.11.08%20AM.jpeg",
      title: "March Past",
      category: "Events",
      type: "image"
    },
    {
      url: "https://customer-assets.emergentagent.com/job_schoolify-17/artifacts/c630jezm_YCPS8.jpeg",
      title: "March Past",
      category: "Events",
      type: "image"
    },
    // Other gallery images
    {
      url: "https://customer-assets.emergentagent.com/job_248403c7-c2c6-44b2-9d63-d9aa2b4e99b6/artifacts/khuofsrh_WhatsApp%20Image%202026-01-20%20at%206.48.59%20AM%20%281%29.jpeg",
      title: "Student Life",
      category: "Campus",
      type: "image"
    },
    {
      url: "https://customer-assets.emergentagent.com/job_248403c7-c2c6-44b2-9d63-d9aa2b4e99b6/artifacts/ikohlqeh_WhatsApp%20Image%202026-01-20%20at%206.48.57%20AM%20%282%29.jpeg",
      title: "Student Life",
      category: "Campus",
      type: "image"
    },
    {
      url: "https://customer-assets.emergentagent.com/job_248403c7-c2c6-44b2-9d63-d9aa2b4e99b6/artifacts/6ar27bzd_WhatsApp%20Image%202026-01-20%20at%206.40.16%20AM%20-%20Copy.jpeg",
      title: "School Activities",
      category: "Events",
      type: "image"
    },
    {
      url: "https://customer-assets.emergentagent.com/job_248403c7-c2c6-44b2-9d63-d9aa2b4e99b6/artifacts/lyvaydxl_WhatsApp%20Image%202026-01-20%20at%206.40.13%20AM%20%281%29.jpeg",
      title: "Debate and Election Day",
      category: "Events",
      type: "image"
    },
    {
      url: "https://customer-assets.emergentagent.com/job_248403c7-c2c6-44b2-9d63-d9aa2b4e99b6/artifacts/d89e8qip_WhatsApp%20Image%202026-01-20%20at%206.40.16%20AM%20%282%29%20-%20Copy.jpeg",
      title: "Career Day",
      category: "Events",
      type: "image"
    },
    {
      url: "https://customer-assets.emergentagent.com/job_248403c7-c2c6-44b2-9d63-d9aa2b4e99b6/artifacts/cezi2obt_WhatsApp%20Image%202026-01-20%20at%206.40.18%20AM.jpeg",
      title: "Annex Morning Assembly",
      category: "Events",
      type: "image"
    },
    // Excursion Images
    {
      url: "https://customer-assets.emergentagent.com/job_b5435c93-033f-4e57-8193-8df477e3abd8/artifacts/wmcxmcyk_image.png",
      title: "Mechanical STEM Education",
      category: "Excursion",
      type: "image"
    },
    {
      url: "https://customer-assets.emergentagent.com/job_b5435c93-033f-4e57-8193-8df477e3abd8/artifacts/hlzg8fjj_image.png",
      title: "Hands-on Equipment Training",
      category: "Excursion",
      type: "image"
    },
    {
      url: "https://customer-assets.emergentagent.com/job_b5435c93-033f-4e57-8193-8df477e3abd8/artifacts/53s207gt_image.png",
      title: "STEM Electronics Workshop",
      category: "Excursion",
      type: "image"
    },
  
    {
      url: "https://customer-assets.emergentagent.com/job_248403c7-c2c6-44b2-9d63-d9aa2b4e99b6/artifacts/oiccwtov_WhatsApp%20Image%202026-01-20%20at%206.40.13%20AM%20%284%29%20-%20Copy.jpeg",
      title: "Campus Tour",
      category: "Campus",
      type: "image"
    },
    {
      url: "https://customer-assets.emergentagent.com/job_prep-dashboard-5/artifacts/7mtxuht9_WhatsApp%20Image%202026-01-20%20at%206.40.11%20AM.jpeg",
      title: "Teachers Award Day",
      category: "Events",
      type: "image"
    },
    {
      url: "https://customer-assets.emergentagent.com/job_prep-dashboard-5/artifacts/7ht35mmu_WhatsApp%20Image%202026-01-20%20at%206.40.12%20AM%20%282%29%20-%20Copy%20-%20Copy.jpeg",
      title: "Election Day",
      category: "Events",
      type: "image"
    },
    {
      url: "https://customer-assets.emergentagent.com/job_prep-dashboard-5/artifacts/4i9htgfj_WhatsApp%20Image%202026-01-20%20at%206.40.12%20AM%20%283%29%20-%20Copy%20-%20Copy%20-%20Copy.jpeg",
      title: "Student Activities",
      category: "Learning",
      type: "image"
    },
    {
      url: "https://customer-assets.emergentagent.com/job_prep-dashboard-5/artifacts/pe713ed8_WhatsApp%20Image%202026-01-20%20at%206.40.14%20AM%20%282%29.jpeg",
      title: "Graduation Day",
      category: "Events",
      type: "image"
    },
    {
      url: "https://customer-assets.emergentagent.com/job_prep-dashboard-5/artifacts/go9vo3fh_WhatsApp%20Image%202026-01-20%20at%206.40.15%20AM%20%282%29%20-%20Copy.jpeg",
      title: "Music Class",
      category: "Arts",
      type: "image"
    },
    {
      url: "https://customer-assets.emergentagent.com/job_prep-dashboard-5/artifacts/uai634vi_WhatsApp%20Image%202026-01-20%20at%206.40.13%20AM%20%283%29%20-%20Copy.jpeg",
      title: "Debate Day",
      category: "Events",
      type: "image"
    },
    {
      url: "https://customer-assets.emergentagent.com/job_prep-dashboard-5/artifacts/g7pdvxgd_WhatsApp%20Image%202026-01-20%20at%206.40.13%20AM.jpeg",
      title: "Election Day",
      category: "Events",
      type: "image"
    },
    {
      url: "https://customer-assets.emergentagent.com/job_prep-dashboard-5/artifacts/38m5anj4_WhatsApp%20Image%202026-01-20%20at%206.40.15%20AM%20%283%29.jpeg",
      title: "Home Economics",
      category: "Arts",
      type: "image"
    },
    {
      url: "https://customer-assets.emergentagent.com/job_prep-dashboard-5/artifacts/qy398s5c_WhatsApp%20Image%202026-01-20%20at%206.40.17%20AM%20%282%29.jpeg",
      title: "Kindergarten Graduation Day",
      category: "Events",
      type: "image"
    },
    {
      url: "https://customer-assets.emergentagent.com/job_prep-dashboard-5/artifacts/geytdxji_WhatsApp%20Image%202026-01-20%20at%206.48.57%20AM.jpeg",
      title: "Library Time",
      category: "Excursion",
      type: "image"
    },
    {
      url: "https://customer-assets.emergentagent.com/job_prep-dashboard-5/artifacts/1wz8s9af_WhatsApp%20Image%202026-01-20%20at%206.48.59%20AM%20%281%29.jpeg",
      title: "Harbour Field Excursion",
      category: "Excursion",
      type: "image"
    },
    {
      url: "https://customer-assets.emergentagent.com/job_prep-dashboard-5/artifacts/5gap90gc_WhatsApp%20Image%202026-01-20%20at%206.40.17%20AM%20%282%29%20-%20Copy.jpeg",
      title: "Career Day",
      category: "Events",
      type: "image"
    },
    {
      url: "https://customer-assets.emergentagent.com/job_prep-dashboard-5/artifacts/yk4zyyop_WhatsApp%20Image%202026-01-20%20at%206.40.17%20AM%20%283%29%20-%20Copy.jpeg",
      title: "Graduation Day",
      category: "Events",
      type: "image"
    },
    {
      url: "https://customer-assets.emergentagent.com/job_prep-dashboard-5/artifacts/hcz9tjsd_WhatsApp%20Image%202026-01-20%20at%206.40.18%20AM.jpeg",
      title: "Annex Campus",
      gpsAddress: "WK-396-6047",
      gpsLink: "https://www.google.com/maps?q=4.910984,-1.775947",
      category: "Events",
      type: "image"
    },
    {
      url: "https://customer-assets.emergentagent.com/job_prep-dashboard-5/artifacts/eytp32rm_WhatsApp%20Image%202026-01-20%20at%206.48.56%20AM%20-%20Copy.jpeg",
      title: "Library Visit",
      category: "Learning",
      type: "image"
    },
    {
      url: "https://customer-assets.emergentagent.com/job_prep-dashboard-5/artifacts/5hv6l85o_WhatsApp%20Image%202026-01-20%20at%206.49.00%20AM%20%281%29%20-%20Copy.jpeg",
      title: "Awards Ceremony",
      category: "Events",
      type: "image"
    },
    {
      url: "https://customer-assets.emergentagent.com/job_schoolify-17/artifacts/azv4ro2b_WhatsApp%20Image%202026-01-20%20at%206.40.17%20AM.jpeg",
      title: "Doctor's Career Day",
      category: "Events",
      type: "image"
    }
  ];

  // Combine all media
  const allMedia = [...galleryVideos, ...galleryImages];
  
  // Get unique categories
  const categories = ["all", ...new Set(allMedia.map(item => item.category))];

  // Filter media based on active tab
  const filteredMedia = activeTab === "all" 
    ? allMedia 
    : allMedia.filter(item => item.category === activeTab);

  const openLightbox = (index) => {
    setCurrentIndex(index);
    setLightboxOpen(true);
  };

  const closeLightbox = () => {
    setLightboxOpen(false);
  };

  const goToPrevious = () => {
    setCurrentIndex((prev) => (prev === 0 ? filteredMedia.length - 1 : prev - 1));
  };

  const goToNext = () => {
    setCurrentIndex((prev) => (prev === filteredMedia.length - 1 ? 0 : prev + 1));
  };

  return (
    <div className="min-h-screen bg-gray-50" data-testid="gallery-page">
      {/* Hero Section */}
      <div className="bg-gradient-to-r from-[#002147] to-[#003366] text-white py-16">
        <div className="max-w-7xl mx-auto px-4 text-center">
          <div className="inline-flex items-center gap-2 bg-white/10 px-4 py-2 rounded-full mb-4">
            <Images size={18} />
            <span className="font-semibold text-sm">Photo & Video Gallery</span>
          </div>
          <h1 className="text-4xl md:text-5xl font-bold mb-4">School Gallery</h1>
          <p className="text-lg text-white/80 max-w-2xl mx-auto">
            Explore our collection of memorable moments, events, and activities at Young Christian Preparatory School.
          </p>
        </div>
      </div>

      {/* Category Filter */}
      <div className="max-w-7xl mx-auto px-4 py-8">
        <div className="flex flex-wrap justify-center gap-2 mb-8">
          {categories.map((category) => (
            <button
              key={category}
              onClick={() => setActiveTab(category)}
              className={`px-4 py-2 rounded-full text-sm font-medium transition-all ${
                activeTab === category
                  ? "bg-[#FF6B00] text-white"
                  : "bg-white text-gray-600 hover:bg-gray-100 border border-gray-200"
              }`}
              data-testid={`filter-${category}`}
            >
              {category === "all" ? "All Media" : category}
            </button>
          ))}
        </div>

        {/* Gallery Grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          {filteredMedia.map((item, index) => (
            <div
              key={index}
              className="relative group overflow-hidden rounded-xl shadow-lg cursor-pointer bg-black aspect-square"
              onClick={() => item.type === "image" && openLightbox(index)}
              data-testid={`gallery-item-${index}`}
            >
              {item.type === "video" ? (
                <video
                  src={item.url}
                  controls
                  className="w-full h-full object-cover"
                  preload="metadata"
                >
                  Your browser does not support the video tag.
                </video>
              ) : (
                <>
                  <img
                    src={item.url}
                    alt={item.title}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                  <div className="absolute bottom-0 left-0 right-0 p-3 text-white transform translate-y-full group-hover:translate-y-0 transition-transform duration-300">
                    <span className="text-xs bg-[#FF6B00] px-2 py-1 rounded-full">{item.category}</span>
                    <h3 className="font-semibold mt-2 text-sm">
                      {item.title}
                      {item.gpsAddress && (
                        <>
                          {" "}
                          <a
                            href={item.gpsLink}
                            target="_blank"
                            rel="noopener noreferrer"
                            onClick={(e) => e.stopPropagation()}
                            className="inline-flex items-center gap-1 text-[#FF6B00] hover:text-yellow-300 underline cursor-pointer transition-colors"
                            data-testid="gps-link"
                          >
                            (GPS: {item.gpsAddress})
                          </a>
                        </>
                      )}
                    </h3>
                  </div>
                </>
              )}
              {item.type === "video" && (
                <div className="absolute top-2 left-2">
                  <span className="bg-[#FF6B00] text-white text-xs px-2 py-1 rounded-full flex items-center gap-1">
                    <Play size={12} /> Video
                  </span>
                </div>
              )}
            </div>
          ))}
        </div>

        {filteredMedia.length === 0 && (
          <div className="text-center py-12 text-gray-500">
            <Camera size={48} className="mx-auto mb-4 opacity-50" />
            <p>No media found in this category.</p>
          </div>
        )}
      </div>

      {/* Lightbox */}
      {lightboxOpen && filteredMedia[currentIndex]?.type === "image" && (
        <div 
          className="fixed inset-0 bg-black/95 z-50 flex items-center justify-center"
          onClick={closeLightbox}
          data-testid="lightbox"
        >
          <button
            className="absolute top-4 right-4 text-white p-2 hover:bg-white/10 rounded-full transition-colors"
            onClick={closeLightbox}
            data-testid="lightbox-close"
          >
            <X size={32} />
          </button>
          
          <button
            className="absolute left-4 text-white p-2 hover:bg-white/10 rounded-full transition-colors"
            onClick={(e) => { e.stopPropagation(); goToPrevious(); }}
            data-testid="lightbox-prev"
          >
            <ChevronLeft size={40} />
          </button>

          <div className="max-w-5xl max-h-[80vh] px-16" onClick={(e) => e.stopPropagation()}>
            <img
              src={filteredMedia[currentIndex].url}
              alt={filteredMedia[currentIndex].title}
              className="max-w-full max-h-[80vh] object-contain rounded-lg"
            />
            <div className="text-center mt-4 text-white">
              <span className="bg-[#FF6B00] px-3 py-1 rounded-full text-sm">
                {filteredMedia[currentIndex].category}
              </span>
              <h3 className="text-xl font-semibold mt-2">
                {filteredMedia[currentIndex].title}
                {filteredMedia[currentIndex].gpsAddress && (
                  <>
                    {" "}
                    <a
                      href={filteredMedia[currentIndex].gpsLink}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-[#FF6B00] hover:text-yellow-300 underline cursor-pointer transition-colors"
                      data-testid="lightbox-gps-link"
                    >
                      (GPS: {filteredMedia[currentIndex].gpsAddress})
                    </a>
                  </>
                )}
              </h3>
              <p className="text-white/60 text-sm mt-1">
                {currentIndex + 1} of {filteredMedia.length}
              </p>
            </div>
          </div>

          <button
            className="absolute right-4 text-white p-2 hover:bg-white/10 rounded-full transition-colors"
            onClick={(e) => { e.stopPropagation(); goToNext(); }}
            data-testid="lightbox-next"
          >
            <ChevronRight size={40} />
          </button>
        </div>
      )}
    </div>
  );
};

export default GalleryPage;
